import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import { BotaoChatComponent } from '../botao-chat/botao-chat.component';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';
import { SuccessGenericoComponent } from '../success-generico/success-generico.component';
import { ErrorGenericoComponent } from '../error-generico/error-generico.component';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { FooterComponent } from '../footer/footer.component';

@Component({
    selector: 'app-page-layout',
    templateUrl: './page-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BotaoChatComponent,
        LoadingGenericoComponent,
        SuccessGenericoComponent,
        ErrorGenericoComponent,
        BreadcrumbComponent,
        FooterComponent,
    ],
})
export class PageLayoutComponent {
  @Input() alertLoading: boolean;
  @Input() alertSucesso: boolean;
  @Input() alertError: boolean;

  // outputs são repassados via template com event binding direto nos filhos
}
